"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _messagePopup = _interopRequireDefault(require("../../message-popup/message-popup"));

const SupportErrorPopup = ({
  onClose
}) => /*#__PURE__*/_react.default.createElement(_messagePopup.default, {
  className: "support-popup",
  onClose: onClose,
  title: 'Uh oh. Your form didn\'t go through.',
  buttons: [{
    value: 'ok',
    name: 'OK',
    onClick: onClose
  }]
}, "Please fill it out and try again.", /*#__PURE__*/_react.default.createElement("br", null), "We're sorry for the inconvenience!");

SupportErrorPopup.propTypes = {
  onClose: _propTypes.default.func.isRequired
};
var _default = SupportErrorPopup;
exports.default = _default;